import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  ref: "root",
  class: "relative inline-flex"
}
const _hoisted_2 = ["title", "aria-label"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M3 7l4.5 3.5L12 4l4.5 6.5L21 7l-1.6 10.2a1 1 0 0 1-1 .8H5.6a1 1 0 0 1-1-.8L3 7z" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("rect", {
  x: "4.5",
  y: "19",
  width: "15",
  height: "2.2",
  rx: "1"
}, null, -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  key: 0,
  class: "absolute right-0 top-full mt-2 z-30 w-48 rounded-lg bg-white p-3 text-left shadow-xl ring-1 ring-black/5"
}
const _hoisted_7 = { class: "flex items-center gap-2" }
const _hoisted_8 = { class: "text-sm font-semibold text-gray-900" }
const _hoisted_9 = { class: "mt-1 text-xs text-gray-500" }
const _hoisted_10 = { class: "text-gray-800" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.categoria)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)), ["stop"])),
          title: `${_ctx.tierName} — desconto de taxa ${_ctx.descontoLabel}`,
          "aria-label": `Categoria ${_ctx.tierName}, desconto de taxa ${_ctx.descontoLabel}`,
          class: "inline-flex items-center justify-center rounded-full p-1 hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-white/40 transition-colors"
        }, [
          (_openBlock(), _createElementBlock("svg", {
            viewBox: "0 0 24 24",
            class: "h-6 w-6 drop-shadow",
            style: _normalizeStyle({ color: _ctx.tierColor }),
            fill: "currentColor",
            "aria-hidden": "true"
          }, _hoisted_5, 4))
        ], 8, _hoisted_2),
        _createVNode(_Transition, {
          "enter-active-class": "transition ease-out duration-100",
          "enter-from-class": "transform opacity-0 scale-95",
          "enter-to-class": "transform opacity-100 scale-100",
          "leave-active-class": "transition ease-in duration-75",
          "leave-from-class": "transform opacity-100 scale-100",
          "leave-to-class": "transform opacity-0 scale-95"
        }, {
          default: _withCtx(() => [
            (_ctx.open)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("span", {
                      class: "inline-block h-3 w-3 rounded-full flex-shrink-0",
                      style: _normalizeStyle({ backgroundColor: _ctx.tierColor })
                    }, null, 4),
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.tierName), 1)
                  ]),
                  _createElementVNode("p", _hoisted_9, [
                    _createTextVNode(" Desconto de taxa: "),
                    _createElementVNode("strong", _hoisted_10, _toDisplayString(_ctx.descontoLabel), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ], 512))
    : _createCommentVNode("", true)
}